<wms-dialog-header title="{{locale.LABEL_ADVANCED_SETTINGS}}: {{liveWidgetSettingsService.activeWidgetScope.name}}" helpTitle="{{locale['LABEL_WIDGET_' + liveWidgetSettingsService.designerType]}}"
                   helpLink="https://docs.wavemaker.com/learn/app-development/widgets/datalive/data-table/"
                   (onClose)="handleClose.emit()"></wms-dialog-header>
<wms-dialog-body className="p-0">
  <tabset class="designer-tabs full-height">
    <tab (selectTab)="liveWidgetSettingsService.selectMainTab()">
      <ng-template tabHeading class="tab-heading">
        <div class="header" title="{{locale['LABEL_WIDGET_' + liveWidgetSettingsService.designerType]}}">
          <span class="text">{{locale['LABEL_WIDGET_' + liveWidgetSettingsService.designerType]}}</span>
        </div>
      </ng-template>
      <div class="node-properties">
        <div class="properties-list">
          <div class="property-subgroup category-section {{liveWidgetSettingsService.basicPropertyGroups.name}}"
               *ngFor="let subGroup of liveWidgetSettingsService.basicPropertyGroups.subGroups | filter: liveWidgetSettingsService.showSubGroup; index as $index">
            <h4 class='property-subgroup-name'
                *ngIf="locale['LABEL_PROPERTYGROUP_'+toUpperCase(subGroup?.name)]">
              {{locale[subGroup.displayKey] ||
            locale['LABEL_PROPERTYGROUP_'+toUpperCase(subGroup?.name)]}}
            </h4>
            <ul>
              <li class="property-{{property}} form-group app-composite-widget clearfix"
                  *ngFor="let property of subGroup.properties | filter: showPropertyInSubGroup; index as $index"
                  [ngClass]="{'align-right': liveWidgetSettingsService.activeWidgetScope?.widgetProps[property]?.alignright}">
                <label
                  class="control-label property-label col-md-2">{{locale[liveWidgetSettingsService.activeWidgetScope?.widgetProps[property]?.displayKey]
                || liveWidgetSettingsService.activeWidgetScope?.widgetProps[property]?.label
                ||
                locale['LABEL_PROPERTY_'+ toUpperCase(property)] || property}}</label>
                <div class="property-value bind-input-wrapper"
                     *ngIf="convertToString(liveWidgetSettingsService.shadowProperties[property]).indexOf('bind:') === 0">
                  <input wmsExpressionError [expression]="liveWidgetSettingsService.shadowProperties[property]"
                         name="wm-property-{{property}}" type="text"
                         class="form-control app-textbox bound-value bound-value-disable"
                         title="{{liveWidgetSettingsService.shadowProperties[property]}}"
                         [ngModel]="liveWidgetSettingsService.shadowProperties[property]"
                         (ngModelChange)="liveWidgetSettingsService.shadowPropertyChange(property, $event)"
                         [readonly]="true" />
                  <button class="wm-icon wms wms-clear clear"
                          (click)="liveWidgetSettingsService.clearProperty(property)"></button>
                </div>

                <div class="property-value bind-input-wrapper"
                     *ngIf="convertToString(liveWidgetSettingsService.shadowProperties[property]).indexOf('bind:') !== 0"
                     [ngClass]="{'select-icon-class': liveWidgetSettingsService.activeWidgetScope.widgetProps[property].widget === 'selecticon'}">
                  <wms-properties-template [isPropPanel]="false"
                    [advancedSettingsMode]="true" [widgetTypeForAds]="'liveFilter-Ads'"
                    [liveWidgetSettingsService]="liveWidgetSettingsService"
                    [context]="liveWidgetSettingsService"
                    [activeWidget]="liveWidgetSettingsService.activeWidgetScope"
                    [property]="property"
                    [shadowProperties]="liveWidgetSettingsService.shadowProperties"
                    [widgetType]="liveWidgetSettingsService.activeWidgetScope?.widgetType"
                    [widgetId]="liveWidgetSettingsService.activeWidgetScope?.widgetId || liveWidgetSettingsService.activeWidgetScope?.name"></wms-properties-template>
                </div>
                <button name="wm-bind-property-{{property}}"
                        *ngIf="liveWidgetSettingsService.activeWidgetScope.widgetProps[property].bindable === 'in-bound' || liveWidgetSettingsService.activeWidgetScope.widgetProps[property].bindable === 'in-out-bound'"
                        (click)="liveWidgetSettingsService.openWidgetBindVariableDialog(liveWidgetSettingsService.activeWidgetScope.widgetProps[property], property)"
                        [disabled]="liveWidgetSettingsService.activeWidgetScope.widgetProps[property].disabled"
                        class="wms wms-link" title="{{locale['LABEL_BIND_VARIABLE']}}"></button>
                <i placement="right" [tooltipAppendToBody]="true"
                   tooltip="{{locale['MESSAGE_HELP_PROPERTY_' + toUpperCase(liveWidgetSettingsService.activeWidgetScope?.widgettype) + '_' + toUpperCase(property)] || locale['MESSAGE_HELP_PROPERTY_' + toUpperCase(property)]}}"
                   class="wms wms-help"></i>
                <div class="row">
                  <p class="help-block col-md-5 col-md-offset-2"
                     *ngIf="locale['MESSAGE_HELP_PROPERTY_' + toUpperCase(property) + '_' + toUpperCase(liveWidgetSettingsService.shadowProperties[property])]">
                    {{locale['MESSAGE_HELP_PROPERTY_' + toUpperCase(property) + '_' +
                  toUpperCase(liveWidgetSettingsService.shadowProperties[property])]}}
                  </p>
                  <p class="help-block col-md-5 col-md-offset-2"
                     *ngIf="!liveWidgetSettingsService.activeWidgetScope.isBoundToLiveVariable && locale['MESSAGE_HELP_PROPERTY_' + toUpperCase(property) + '_' + toUpperCase(liveWidgetSettingsService.shadowProperties[property])]">
                    {{locale.MESSAGE_HELP_NOT_ON_ENTIRE_DATASET}}</p>
                </div>

              </li>
            </ul>

          </div>
        </div>
      </div>
    </tab>
    <tab (selectTab)="liveWidgetSettingsService.selectFieldsTab()">
      <ng-template tabHeading class="tab-heading">
        <div class="header" title="{{locale['LABEL_PROPERTY_FIELDS']}}">
          <span class="text">{{locale.LABEL_PROPERTY_FIELDS}}</span>
        </div>
      </ng-template>
      <div wms-split-panel split="vertical" showdividers="true" class="split-panel vertical">
        <div wms-split-pane limit="230" class="split-pane" width="25%" style="width: 25%;">
          <div class="primary-panel">
            <div class="search-container">
              <wms-search name="wm-livewidget-search-key" (onSearch)="searchFields($event)"
                          name="usecase-search-box"></wms-search>
            </div>
            <div class="list-head">
              <div class="item">
                                <span class="checkbox-container"><i title="{{locale.LABEL_PROJECTS_LIST_WEB}}"
                                                                    class="wm-icon wms wms-desktop form-tab-icon"></i></span>
                <span class="checkbox-container"><i name="wm-mobile-icon"
                                                    title="{{locale.LABEL_PROJECTS_LIST_MOBILE}}"
                                                    class="wm-icon wms wms-mobile form-tab-icon"></i></span>
                <span class="checkbox-container"><i name="wm-tablet-icon"
                                                    title="{{locale.LABEL_TABLET}}"
                                                    class="wm-icon wms wms-tab form-tab-icon"></i></span>
              </div>
            </div>
            <div class="list-head">
              <div class="item">
                                <span class="checkbox-container"><input class="app-checkbox" type="checkbox"  [attr.name]="'pcDisplay-selectAll'"
                                                                        [(ngModel)]="liveWidgetSettingsService.componentDefnObject.isSelectAll.field.pcDisplay"
                                                                        (ngModelChange)="liveWidgetSettingsService.selectAll('field', 'pcDisplay')" /></span>
                <span class="checkbox-container"><input class="app-checkbox" type="checkbox" [attr.name]="'mobileDisplay-selectAll'"
                                                        [(ngModel)]="liveWidgetSettingsService.componentDefnObject.isSelectAll.field.mobileDisplay"
                                                        (ngModelChange)="liveWidgetSettingsService.selectAll('field', 'mobileDisplay')" /></span>
                <span class="checkbox-container"><input class="app-checkbox" type="checkbox" [attr.name]="'tabletDisplay-selectAll'"
                                                        [(ngModel)]="liveWidgetSettingsService.componentDefnObject.isSelectAll.field.tabletDisplay"
                                                        (ngModelChange)="liveWidgetSettingsService.selectAll('field', 'tabletDisplay')" /></span>
                <span>{{locale.LABEL_WIDGET_DESIGNER_SELECT_ALL}}</span>
                <button title="{{locale.LABEL_ADD_COLUMN}}"
                        class="button-primary btn wms wms-plus btn-sm add-button"
                        (click)="addCustomComponent('field')"></button>
              </div>
            </div>
            <div class="row angular-ui-tree">
              <ol class="list-items fields-list angular-ui-tree-nodes">
                <li *ngFor="let columnDef of liveWidgetSettingsService.componentDefnObject.field | filter: 'displayname': fieldsKey; index as i"
                    [ngClass]="{'active': columnDef.key === liveWidgetSettingsService.selectedComponent.field.key}"
                    class="list-item first-level angular-ui-tree-node">
                  <wms-live-widgets-fields-list [columnDef]="columnDef"
                                                (updateSelectedComponent)="updateSelectedComponent($event.componentDef, $event.componentType, i, $event.event)"></wms-live-widgets-fields-list>
                </li>
              </ol>
            </div>
            <div class="settings-actions clearfix">
              <button title="{{locale.LABEL_MOVE_UP}}" class="wm-icon12 move-item-arrow wms wms-arrow-up"
                      (click)="liveWidgetSettingsService.moveSelectedComponent(liveWidgetSettingsService.DIRECTION.UP, 'field')"></button>
              <button title="{{locale.LABEL_MOVE_DOWN}}"
                      class="wm-icon12 move-item-arrow wms wms-arrow-down"
                      (click)="liveWidgetSettingsService.moveSelectedComponent(liveWidgetSettingsService.DIRECTION.DOWN, 'field')"></button>
            </div>
          </div>
        </div>
        <div wm-split-pane limit="610" width="75%" class="split-pane" style="width: 75%;">
          <div class="secondary-panel">
            <wms-form-filter-basic class="full-height no-tabs"></wms-form-filter-basic>
          </div>
        </div>
      </div>
    </tab>
    <tab (selectTab)="liveWidgetSettingsService.selectActionsTab()">
      <ng-template tabHeading class="tab-heading">
        <div class="header" title="{{locale.LABEL_ACTIONS}}">
          <span class="text">{{locale.LABEL_ACTIONS}}</span>
        </div>
      </ng-template>
      <div wms-split-panel split="vertical" class="split-panel vertical">
        <div wms-split-pane limit="230" width="25%" class="split-pane" width="25%" style="width: 25%">
          <div class="primary-panel">
            <div class="search-container">
              <wms-search (onSearch)="searchActions($event)" name="wm-livewidget-search-key"></wms-search>
            </div>
            <div class="grid-actions-list"
                 *ngIf="liveWidgetSettingsService.designerType === 'LIVEFILTER'">
              <div class="list-head action-header">
                <div class="item">
                                    <span class="checkbox-container">
                                        <input class="app-checkbox" type="checkbox"
                                               [(ngModel)]="liveWidgetSettingsService.componentDefnObject.isSelectAll.button.include"
                                               (ngModelChange)="liveWidgetSettingsService.selectAll('button', 'include')" />
                                    </span>
                  <span class="title">{{locale.LABEL_WIDGET_DESIGNER_SELECT_ALL}}</span>
                  <button class="button-primary btn wms wms-plus add-button"
                          title="{{locale.LABEL_ADD_COLUMN}}"
                          *ngIf="liveWidgetSettingsService.designerType === 'LIVEFILTER' || liveWidgetSettingsService.designerType === 'FORM'"
                          (click)="addCustomComponent('button')"></button>
                </div>
              </div>
              <ul class="list-items fields-list">
                <li class="list-item"
                    *ngFor="let buttonDef of liveWidgetSettingsService.componentDefnObject.button | filter: 'displayName': actionSearchKey; index as i"
                    (click)="updateSelectedComponent(buttonDef, 'button', i)"
                    tooltip="{{locale['LABEL_GRID_ACTION_' + toUpperCase(buttonDef?.displayName)]}}"
                    [ngClass]="{'active':buttonDef.key === liveWidgetSettingsService.selectedComponent.button.key}"
                    placement="bottom" [tooltipAppendToBody]="true"  >
                  <div class="item" [ngClass]="{'marked-deleted': buttonDef.remove}">
                                        <span class="checkbox-container">
                                            <input class="app-checkbox" id="{{buttonDef?.displayName}}" type="checkbox"
                                                   [(ngModel)]="buttonDef.include"
                                                   [ngModelOptions]="{updateOn: 'change'}"
                                                   (ngModelChange)="liveWidgetSettingsService.updateSelectAll('button', 'include', buttonDef)" />
                                        </span>
                    <!-- TODO -->
                    <span
                      class="title">{{liveWidgetSettingsService.getDisplayName(buttonDef)}}</span>
                    <i class="wm-icon wms hover-fix"
                       title="{{buttonDef.remove ? locale.LABEL_RESTORE_ACTION : locale.LABEL_DELETE_ACTION}}"
                       [ngClass]="{'wms-undo undo': buttonDef.remove, 'wms-delete delete-icon': !buttonDef.remove}"
                       (click)="buttonDef.remove = !buttonDef.remove"></i>
                  </div>
                </li>
              </ul>
            </div>

            <div class="form-actions-list" *ngIf="liveWidgetSettingsService.designerType === 'LIVEFORM'">
              <div class="list-head action-header">
                <div class="item">
                                    <span class="checkbox-container">
                                        <input class="app-checkbox" type="checkbox"
                                               [(ngModel)]="liveWidgetSettingsService.componentDefnObject.isSelectAll.button.include"
                                               (ngModelChange)="liveWidgetSettingsService.selectAll('button', 'include')" />
                                    </span>
                  <span class="title">{{locale.LABEL_WIDGET_DESIGNER_SELECT_ALL}}</span>
                </div>
              </div>
              <ul class="list-items fields-list actions">
                <li class="list-head action-header">
                  <div class="item clearfix">
                    <span class="title pull-left">{{locale.LABEL_PROPERTY_EDITMODE}}</span>
                    <button class="button-primary btn wms wms-plus btn-sm add-button"
                            (click)="addCustomComponent('button', true)"></button>
                  </div>
                </li>
                <li class="list-item"
                    *ngFor="let buttonDef of liveWidgetSettingsService.componentDefnObject.button | filter: 'updateMode': true | filter: 'displayName': actionSearchKey; index as i"
                    (click)="updateSelectedComponent(buttonDef, 'button', i)"
                    tooltip="{{locale['LABEL_ACTION_' + toUpperCase(buttonDef?.displayName)]}}"
                    [ngClass]="{'active':buttonDef.key === liveWidgetSettingsService.selectedComponent.button.key}"
                    placement="bottom" [tooltipAppendToBody]="true">
                  <div class="item" [ngClass]="{'marked-deleted': buttonDef.remove}">
                                        <span class="checkbox-container">
                                            <input class="app-checkbox" type="checkbox" [(ngModel)]="buttonDef.include"
                                                   (ngModelChange)="liveWidgetSettingsService.updateSelectAll('button', 'include', buttonDef)" />
                                        </span>
                    <span class="title">{{liveWidgetSettingsService.getDisplayName(buttonDef)}}</span>
                    <i class="wm-icon wms hover-fix"
                       title="{{buttonDef.remove ? locale.LABEL_RESTORE_ACTION : locale.LABEL_DELETE_ACTION}}"
                       [ngClass]="{'wms-undo undo': buttonDef.remove, 'wms-delete delete-icon': !buttonDef.remove}"
                       (click)="buttonDef.remove = !buttonDef.remove"></i>
                  </div>
                </li>
                <li class="list-head action-header">
                  <div class="item clearfix">
                    <span class="title pull-left">{{locale.LABEL_PROPERTY_VIEWMODE}}</span>
                    <button class="button-primary btn wms wms-plus btn-sm add-button"
                            (click)="addCustomComponent('button', false)"></button>
                  </div>
                </li>
                <li class="list-item"
                    *ngFor="let buttonDef of liveWidgetSettingsService.componentDefnObject.button | filter: 'updateMode': false | filter: 'displayName': actionSearchKey; index as i "
                    (click)="updateSelectedComponent(buttonDef, 'button', i)"
                    tooltip="{{locale['LABEL_ACTION_' + toUpperCase(buttonDef?.displayName)]}}"
                    [ngClass]="{active:buttonDef.key === liveWidgetSettingsService.selectedComponent.button.key}"
                    placement="bottom" [tooltipAppendToBody]="true">
                  <div class="item" [ngClass]="{'marked-deleted': buttonDef.remove}">
                                        <span class="checkbox-container">
                                            <input class="app-checkbox" type="checkbox" [(ngModel)]="buttonDef.include"
                                                   (ngModelChange)="liveWidgetSettingsService.updateSelectAll('button', 'include', buttonDef)" />
                                        </span>
                    <span class="title">{{liveWidgetSettingsService.getDisplayName(buttonDef)}}</span>
                    <i class="wm-icon wms hover-fix"
                       title="{{buttonDef.remove ? locale.LABEL_RESTORE_ACTION : locale.LABEL_DELETE_ACTION}}"
                       [ngClass]="{'wms-undo undo': buttonDef.remove, 'wms-delete delete-icon': !buttonDef.remove}"
                       (click)="buttonDef.remove = !buttonDef.remove"></i>
                  </div>
                </li>
              </ul>
            </div>
            <div class="settings-actions"
                 [ngClass]="{'table-settings-actions': liveWidgetSettingsService.designerType === 'TABLE'}">
              <button class="wm-icon12 move-item-arrow wms wms-arrow-up" title="{{locale.LABEL_MOVE_UP}}"
                      (click)="liveWidgetSettingsService.moveSelectedComponent(liveWidgetSettingsService.DIRECTION.UP, 'button')"></button>
              <button class="wm-icon12 move-item-arrow wms wms-arrow-down"
                      title="{{locale.LABEL_MOVE_DOWN}}"
                      (click)="liveWidgetSettingsService.moveSelectedComponent(liveWidgetSettingsService.DIRECTION.DOWN, 'button')"></button>
            </div>
          </div>
        </div>
        <div wm-split-pane limit="525" width="75%" class="split-pane" style="width: 75%;">
          <div class="secondary-panel">
            <tabset class="full-height">
              <tab (selectTab)="liveWidgetSettingsService.selectPropertyGroup(liveWidgetSettingsService.propertyGroups[0])"
                   title="{{locale.LABEL_WIDGET_DESIGNER_GROUP_BASIC}}">
                <ng-template tabHeading
                             class="tab-heading">{{locale.LABEL_WIDGET_DESIGNER_GROUP_BASIC}}</ng-template>
                <!--Actions - Basic-->
                <wms-actions-basic (validateAndUpdateExpression)="liveWidgetSettingsService.validateAndUpdateExpression($event)" [rowactionspositions]="liveWidgetSettingsService.rowactionspositions"
                                   [selectedcomponent]="liveWidgetSettingsService.selectedComponent"></wms-actions-basic>
              </tab>
              <!--Security tab.-->
              <tab *ngIf="(!liveWidgetSettingsService.isPrefabType && !liveWidgetSettingsService.isTemplateBundleType && liveWidgetSettingsService.activeTab.type === 'actions') && !(liveWidgetSettingsService.componentDefnObject.isLayout)"
                   (selectTab)="liveWidgetSettingsService.selectPropertyGroup(liveWidgetSettingsService.propertyGroups[1]);"
                   title="{{locale.LABEL_WIDGET_DESIGNER_GROUP_SECURITY}}">
                <ng-template tabHeading class="tab-heading">
                  {{locale.LABEL_WIDGET_DESIGNER_GROUP_SECURITY}}
                </ng-template>
                <!--Security Container-->
                <wms-security [liveWidgetSettings]="liveWidgetSettingsService"></wms-security>
              </tab>
            </tabset>
          </div>
        </div>
      </div>
    </tab>
  </tabset>
</wms-dialog-body>
<wms-dialog-footer>
  <button (click)="handleClose.emit()" class="btn app-button button-secondary"
          title="{{locale.LABEL_CANCEL}}">{{locale.LABEL_CANCEL}}</button>
  <button (click)="liveWidgetSettingsService.saveDesignerSettings()" class="btn app-button button-primary"
          [disabled]="liveWidgetSettingsService.saveDisabled" title="{{locale.LABEL_SAVE}}">{{locale.LABEL_SAVE}}</button>
</wms-dialog-footer>
<wms-dialog id="tableSettingsSelectIconDialog" customClasses="wm-select-icon-dialog medium wm-studio-dialog" [content]="selectIconContent"></wms-dialog>
<ng-template #selectIconContent>
  <wms-icon-selector (handleChanges)="liveWidgetSettingsService.handleIconChooserDialogChanges($event.boundVariable)"  (handleClose)="liveWidgetSettingsService.dialogService.close('tableSettingsSelectIconDialog')" ></wms-icon-selector>
</ng-template>


